import { render, staticRenderFns } from "./dyPreviewBox.vue?vue&type=template&id=c3c3ca8c&scoped=true&"
import script from "./dyPreviewBox.vue?vue&type=script&lang=js&"
export * from "./dyPreviewBox.vue?vue&type=script&lang=js&"
import style0 from "./dyPreviewBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dyPreviewBox.vue?vue&type=style&index=1&id=c3c3ca8c&lang=less&scoped=true&"
import style2 from "./dyPreviewBox.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c3ca8c",
  null
  
)

component.options.__file = "dyPreviewBox.vue"
export default component.exports